import { render } from "./confirmedAmount.vue?vue&type=template&id=659b852c&scoped=true"
import script from "./confirmedAmount.vue?vue&type=script&lang=js"
export * from "./confirmedAmount.vue?vue&type=script&lang=js"

import "./confirmedAmount.vue?vue&type=style&index=0&id=659b852c&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/vas-web-client-pre/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659b852c"]])